import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionName, buildPlxData,
} from '../common/styles';
import {
  BaseContainer, BaseDesc, BaseTitle,
} from './styles';

const vPadding = 170;
const Container = styled(BaseContainer)`
  ${props => (props.theme.isMobile ? `
    margin-top: 85px;
  ` : `
    margin-top: ${vPadding + 8}px;
    margin-bottom: ${vPadding + 8}px;
  `)};
`;

const FootprintImg = styled(Img)`
  position: relative;
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    margin-left: -40px;
    max-width: 542px;
  `)};
`;

export default function Footprint() {
  const { footprintImg, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#footprint-container', vPadding);

  return (
    <Container id="footprint-container">
      <Plx className="base-section" parallaxData={plxData.image} disabled={isMobile}>
        <FootprintImg src={footprintImg} />
      </Plx>
      <Plx className="right-section" parallaxData={plxData.text} disabled={isMobile}>
        <SectionName>Solutions</SectionName>
        <BaseTitle>Enhance your online footprint</BaseTitle>
        <BaseDesc>
          Livewire&apos;s content distribution network includes Australian Financial Review,
          IRESS, Google News and Bloomberg.
        </BaseDesc>
      </Plx>
    </Container>
  );
}
